module.exports = __webpack_public_path__ + "static/media/05-fernando-ximenes.2410680f.webp";